import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";

import {
  AppDataPostTags,
  UNIQUE_CAMPAIGN_URL_TAG,
} from "../../../../shared/models/appData";
import { CampaignType } from "../../../../shared/enums/campaign.enums";
import { PostTargetPlatforms } from "../../../../shared/enums/campaignPost.enums";
import { CustomFormValidators } from "../../../../shared/validators/custom-form-validators";

interface PlatformSelection {
  instagram: boolean;
  facebook: boolean;
}

@Component({
  selector: "app-brand-campaign-content-form-post-suggested-text",
  templateUrl:
    "./brand-campaign-content-form-post-suggested-text.component.html",
  styleUrl: "./brand-campaign-content-form-post-suggested-text.component.scss",
})
export class BrandCampaignContentFormPostSuggestedTextComponent
  implements OnInit
{
  @Input({ required: true }) public postTags!: AppDataPostTags[];
  @Input({ required: true }) public type!: CampaignType;
  @Input() public disableCampaignUniqueUrlWarning = false;
  @Input() public text?: string;
  @Input() public maxLength?: number;
  @Input() public platform: PostTargetPlatforms = PostTargetPlatforms.Facebook;
  @Input() public platformsSelected?: PlatformSelection = {
    instagram: true,
    facebook: true,
  };

  @Output() public textChanged = new EventEmitter<string>();

  protected readonly PostTargetPlatforms = PostTargetPlatforms;
  protected readonly UNIQUE_CAMPAIGN_URL_TAG = UNIQUE_CAMPAIGN_URL_TAG;
  protected readonly CampaignType = CampaignType;
  protected formControl!: FormControl;

  public ngOnInit(): void {
    this.formControl = new FormControl(this.text ?? "", [
      Validators.required,
      CustomFormValidators.hasUnrecognizedTag(this.postTags),
      ...(this.maxLength ? [Validators.maxLength(this.maxLength)] : []),
    ]);
  }

  public get isValid(): boolean {
    this.formControl?.updateValueAndValidity();
    return this.formControl?.valid;
  }

  protected addPostTextTag(tag: string): void {
    this.formControl.setValue(`${this.formControl.value} ${tag}`);
    this.reflectTextChanges();
  }

  protected checkContainsUniqueCampaignUrl(): boolean {
    return (
      this.formControl.value.includes(UNIQUE_CAMPAIGN_URL_TAG) ||
      this.type === CampaignType.DownloadOnly
    );
  }

  protected reflectTextChanges(): void {
    if (!this.formControl.touched) {
      this.formControl.markAsTouched();
    }

    this.textChanged.emit(this.formControl.value);
  }
}
